import React from "react";
import GastosNegocios from "../../components/GastosNegocios";
import Navbar from "../../components/Navbar";

const GastoNegocios = () => {
  return (
    <div className="container">
      <Navbar />

      <GastosNegocios />
    </div>
  );
};

export default GastoNegocios;
